class PopupUtil {
  // /**
  //  * @description Binds event listeners for the info window
  //  *
  //  * @param {Object} marker - Instance of Google Maps Marker class
  //  * @param {Object} map - google map
  //  *
  //  * @return {void}
  //  */
  // bindInfoWindowListeners(marker, map) {
  //   const { google } = window;

  //   google.maps.event.addListener(map, 'center_changed', () => {
  //     const getProjection = this.overlay.getProjection();
  //     const pos = getProjection.fromLatLngToContainerPixel(marker.getPosition());
  //   });

  //   google.maps.event.addListener(map, 'bounds_changed', () => {
  //     const getProjection = this.overlay.getProjection();
  //     const pos = getProjection.fromLatLngToContainerPixel(marker.getPosition());
  //   });
  // }

  /**
   * @description Handles opening info window (eg. trip planner window)
   *
   * @param {Object} marker - Map marker object
   *
   * @return {Object} pos - info window position in pixels.
   */
  handleInfoWindow(marker, map, doPan = true) {
    // this.bindInfoWindowListeners(marker, map);
    const pos = this.overlay.getProjection().fromLatLngToContainerPixel(marker.getPosition());

    if (doPan) {
      map.panTo(marker.getPosition());
    }

    return pos;
  }

  /**
   * @description Instantiates an overlay for display custom elements on top of the map
   *
   * @param {Object} map - google map
   *
   * @return {void}
   */
  initOverlayView(map) {
    const { google } = window;

    google.maps.event.addListener(map, 'projection_changed', () => {
      this.overlay = new google.maps.OverlayView();
      this.overlay.draw = () => {};
      this.overlay.setMap(map);
    });
  }
}

export default new PopupUtil();
